import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import FormPermissionService from "../../Setup/controller/FormPermissionController/FormPermissionController";
import CustomerService from "../Controller/CustomerController";
import CreateCustomerModal from "./CreateCustomer";
import useFormSubmission from '../../Auth/Controller/AuthController';
import ModuleService from '../../Setup/controller/ModuleController/ModuleController';
import { SidebarContext } from '../../Layout/SidebarContext';
import Common from '../../Common/Common';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import HelpSite from "../../Common/HelpLink";
import SageService from '../../Sage/Controller/SageController';
import QuickbookService from '../../Quickbook/QuickbookController';
import XeroService from '../../Xero/XeroController';
import { useTranslation } from 'react-i18next';
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
import UserDropdown from "../../Common/UserDropdown";
import LeadService from "../../Lead/Controller/LeadController"
import SendEmail from "../../Common/SendEmail";
import MultipleEmail from "../../Common/MultipleEmail";
import CustomerEmailingList from "../../Common/EmailingName";
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";
import InboxModal from "../../Common/InboxModal";
import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';
import Draggable from 'react-draggable';
import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../config/config";
import { PDFDocument } from "pdf-lib";
import ImportTableService from "../../Setup/controller/ImportTables/ImportTable";
function CustomerList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const url = new URL(window.location.origin + location.pathname);
  const pathname = "/customer/customer-list";
  const RoleID = localStorage.getItem('RoleID');
  const HelpLink = localStorage.getItem('HelpLink');
  const CompanyID = localStorage.getItem("CompanyID");
  const FormAction = "/CustomerList";
  // FormPermissionService.HasPerimssion(() => navigate('/'), RoleID, FormAction);
  const { theme, toggleTheme } = useContext(ThemeContext);

  let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
  const [customerList, setCustomerData] = useState([]);
  const tableRef = useRef();
  const [modalInstance, setModalInstance] = useState(null);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false);
  const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState("0");
  const [financialSoftwareID, setFinancialSoftwareID] = useState("0");
  const [multipleIds, setMultipleIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [poCount, setPOCount] = useState(0);
  const activeDateFormat = useDateFormat();
  const UserID = localStorage.getItem("UserID");
  const [recentSearches, setRecentSearches] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedRoleName, setRoleName] = useState(localStorage.getItem("RoleName"));
  const [LeadIDForEmail, setLeadIDForEmail] = useState();
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isCustomerEmailing, setIsCustomerEmailing] = useState(false);
  const [Email, setEmail] = useState();
  const [emailName, setEmailName] = useState("");
  const [isMultipleEmailModalOpen, setIsMultipleEmailModalOpen] = useState(false);
  const [multipleEmails, setMultipleEmails] = useState([]);
  const setSortConfigInCookie = (config) => {
    Cookies.set(`CustomerSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`CustomerSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'ClientCompanyID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());


  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);
  const handleCheckboxClick = (event, id, index) => {
    event.stopPropagation();

    const isChecked = event.target.checked;

    if (event.shiftKey && lastCheckedIndex !== null) {
      const start = Math.min(lastCheckedIndex, index);
      const end = Math.max(lastCheckedIndex, index);
      const idsInRange = customerList.slice(start, end + 1).map(l => l.ClientCompanyID);

      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) {
          idsInRange.forEach(x => s.add(x));     // range select
        } else {
          idsInRange.forEach(x => s.delete(x));  // range unselect
        }
        return Array.from(s);
      });
    } else {
      // normal single toggle
      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) s.add(id); else s.delete(id);
        return Array.from(s);
      });
    }

    // Always update the anchor index
    setLastCheckedIndex(index);
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    UserLockRelease();
    fetchCustomer(currentPage, pageSize);
    fetchCompanySetup();
    fetchSearchLog();
  }, [currentPage, pageSize]);
  useEffect(() => {
    fetchCustomer(currentPage, pageSize);
    fetchCompanySetup();

  }, [sortConfig]);

  async function fetchCompanySetup() {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const ClientID = localStorage.getItem('CompanyID');
      const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
      setFinancialSoftwareID(companySetup[0].FinancialSoftware);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }
  async function fetchSearchLog() {
    try {

      const searchList = await CustomerService.GetSearchLog("2");
      setRecentSearches(searchList);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }


  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const fetchCustomer = async (page, size, emaailname = "") => {
    try {

      setLoading(true);
      localStorage.setItem('ClientCompanyID', "");

      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();


      const customerData = await CustomerService.GetAllNewCustomers(redirectCallback, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), emailName.toString(), searchColumns.toString());
      setCustomerData(customerData);

      const leadCount = await CustomerService.GetCustomerCount(redirectCallback, searchQuery, emailName.toString(), searchColumns.toString());
      setPOCount(leadCount[0].TotalRecords);
      setTotalPages(Math.ceil(leadCount[0].TotalRecords / size));
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
    finally {
      setLoading(false); // Stop loading after fetching
    }
  };

  useEffect(() => {
    const fetchData = async () => {

      await fetchCustomer("0", pageSize);
    };
    fetchData();
  }, []);



  const handleCloseModal = async (isChanged) => {
    const closeModal = async () => {
      await CustomerService.UnLockCustomer(localStorage.getItem('ClientCompanyID'));
      if (localStorage.getItem('HasRecordUpdated') == "1") {
        fetchCustomer("0", pageSize);
      }
      setMultipleIds([]);
      setIsModalOpen(false);
    };

    if (isChanged != true) {
      closeModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to close this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        closeModal();
      }
    });
  };
  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('confirmDelete')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await CustomerService.DeleteCustomer(multipleIds);
            setMultipleIds([]);
            fetchCustomer("0", pageSize);
            setSelectedId("0");
            Swal.fire(
              'Deleted!',
              'Your record has been deleted.',
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        t('error'),
        t('checkOneRecord'),

        'warning'
      );
    }
  };

  const handleSynchronize = async (event) => {
    event.stopPropagation(); // Prevent the row click event

    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (multipleIds.length > 0) {
      Swal.fire({
        title: t('syncConfirmation'),
        text: t('syncWarning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('confirmSync')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const redirectCallback = () => {
              navigate('/'); // Redirect to the login page
            };


            const postData = await CustomerService.SyncCustomerToFinancial(multipleIds);
            if (postData && postData.message === "Data saved successfully") {
              Swal.fire(
                'Success!',
                'The data has been processed and will be fully synced shortly.',
                'success'
              );
              await fetchCustomer("0", pageSize);
            }
            /*  const ClientID = localStorage.getItem('CompanyID');
              const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
              
  
  
  
              let syncData;
              debugger;
              if (companySetup[0].FinancialSoftware.toString() === "0") {
                Swal.fire(
                  'Warning!',
                  'Please select the financial software from Administration that you wish to integrate.',
                  'warning'
                );
  
              }
              else if (companySetup[0].FinancialSoftware.toString() === "1") {
                syncData = await SageService.SageAddCustomer(ID);
                if (syncData) {
                  if (syncData.data.message === "Data saved successfully") {
                    Swal.fire(
                      'Success!',
                      'Data Synced Successfully.',
                      'success'
                    );
                    await fetchCustomer("0", pageSize);
                  }
                }
  
              }
              else if (companySetup[0].FinancialSoftware.toString() === "2") {
                syncData = await QuickbookService.QuickbookAddCustomer(ID);
                if (syncData) {
                  if (syncData.data.message === "Data saved successfully") {
                    Swal.fire(
                      'Success!',
                      'Data Synced Successfully.',
                      'success'
                    );
                    await fetchCustomer("0", pageSize);
                  }
                }
              }
              else if (companySetup[0].FinancialSoftware.toString() === "3") {
                syncData = await XeroService.XeroAddCustomer(ID);
                if (syncData) {
                  if (syncData.data.message === "Data saved successfully") {
                    Swal.fire(
                      'Success!',
                      'Data Synced Successfully.',
                      'success'
                    );
                    await fetchCustomer("0", pageSize);
                  }
                
  
              }}*/

          } catch (error) {
            debugger;
            alert(error);
            Swal.fire(
              'Error!',
              'There was a problem in synchronizing the record.',
              'error'
            );
            await fetchCustomer("0", pageSize);
          }
        }
      });
    }
    else {
      Swal.fire(
        t('error'),
        t('checkOneRecord'),
        'warning'
      );
    }

  };

  const handleCreateCustomerClick = () => {
    localStorage.setItem('ClientCompanyID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    setShowAssetDetailModal(true);
    setIsModalOpen(true);
  };
  const fetchCustomerDetail = async (CustomerID) => {
    try {
      const CustomerDetail = await CustomerService.GetCustomerByID(redirectCallback, CustomerID);
      return CustomerDetail;

    } catch (error) {
      console.error('Error fetching customer details:', error);
    }
  };

  const [shouldAutoSelect, setShouldAutoSelect] = useState(null);
  useEffect(() => {
    if (shouldAutoSelect && customerList.length > 0) {
      const customerToSelect =
        shouldAutoSelect === 'next'
          ? customerList[0] // first item of new page
          : customerList[customerList.length - 1]; // last item of previous page

      localStorage.setItem('ClientCompanyID', customerToSelect.ClientCompanyID);
      setSelectedId(customerToSelect.ClientCompanyID);
      setShouldAutoSelect(null); // reset
    }
  }, [customerList]);
  const handleNext = async (isChanged) => {
    const nextModal = async () => {
      const customerID = localStorage.getItem('ClientCompanyID');
      const currentIndex = customerList.findIndex(item => item.ClientCompanyID.toString() === customerID);
      await CustomerService.UnLockCustomer(customerID);
      if (currentIndex < customerList.length - 1) {
        const nextLead = customerList[currentIndex + 1];
        localStorage.setItem('ClientCompanyID', nextLead.ClientCompanyID);
        setSelectedId(nextLead.ClientCompanyID);
      } else if (currentPage < totalPages) {
        setShouldAutoSelect('next'); // flag for useEffect
        setCurrentPage(prev => prev + 1);
      }
    };

    if (isChanged != true) {
      nextModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to go to next record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then(async (result) => {
      if (result.isConfirmed) {
        nextModal();
      }
    });
  };

  const handlePrevious = async (isChanged) => {
    const prevModal = async () => {
      const leadID = localStorage.getItem('ClientCompanyID');
      const currentIndex = customerList.findIndex(item => item.ClientCompanyID.toString() === leadID);
      await CustomerService.UnLockCustomer(leadID);
      if (currentIndex > 0) {
        const prevLead = customerList[currentIndex - 1];
        localStorage.setItem('ClientCompanyID', prevLead.ClientCompanyID);
        setSelectedId(prevLead.ClientCompanyID);
      } else if (currentPage > 1) {
        setShouldAutoSelect('previous'); // flag for useEffect
        setCurrentPage(prev => prev - 1);
      }
    };

    if (isChanged != true) {
      prevModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to go to previous record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then(async (result) => {
      if (result.isConfirmed) {
        prevModal();
      }
    });
  };
  const handleEditClick = async (ClientCompanyID) => {
    const IsAlreadyLeadID = localStorage.getItem('ClientCompanyID');
    if (IsAlreadyLeadID) {
      await CustomerService.UnLockCustomer(IsAlreadyLeadID);
    }

    const CustomerDetail = await fetchCustomerDetail(ClientCompanyID);
    if (CustomerDetail.length > 0) {

      localStorage.setItem('PrevPath', "CustomerList");
      localStorage.setItem('HasRecordUpdated', "0");
      localStorage.setItem('ClientCompanyID', ClientCompanyID);
      setSelectedId(ClientCompanyID);
      setIsModalOpen(true);

    }
  };

  const truncateText = (text, maxLength = 15) => {
    if (!text) return '';  // Return empty string if text is null or empty
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };


  // Pdf Report
  const generatePDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text('Customer List Report', 14, 22);

    // Add table using autoTable
    doc.autoTable({
      head: [['Customer', 'Address', 'City', 'Post Code', 'Phone', 'Account Ref']],
      body: customerList.map(customer => [
        truncateText(customer.CompanyName),
        truncateText(customer.Address1),
        truncateText(customer.City),
        truncateText(customer.Postcode),
        truncateText(customer.Phone1),
        truncateText(customer.AccountRef)
      ]),
      startY: 30,
    });

    // Save the PDF
    doc.save('customer_list_report.pdf');
  };
  const handleCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
    setMultipleIds((prevSelectedIds) => {
      if (event.target.checked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };

  const handlePageChange = (page) => {
    setCustomerData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setCustomerData([]); // Clear previous data
    const query = searchQuery.toLowerCase(); // Use current searchQuery state
    let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
    setSearchOptions(columnsToSearch);
    const leadData = await CustomerService.GetAllNewCustomers(redirectCallback, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), emailName.toString(), columnsToSearch.toString());
    setCustomerData(leadData);

    const leadCount = await CustomerService.GetCustomerCount(redirectCallback, searchQuery, emailName.toString(), columnsToSearch.toString());
    setPOCount(leadCount[0].TotalRecords);
    setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically

    const searchList = await CustomerService.GetSearchLog("2");
    setRecentSearches(searchList);
  };
  const handleSort = async (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);
    setCurrentPage(1);

    setSortConfig({ key, direction });
    const porderData = await CustomerService.GetAllNewCustomers(redirectCallback, "1", pageSize.toString(),
      searchQuery.toString(), key.toString(), direction.toString(), emailName.toString(), searchColumns.toString());

    const porderCount = await CustomerService.GetCustomerCount(redirectCallback, searchQuery, emailName.toString(), searchColumns.toString());

    setPOCount(porderCount[0].TotalRecords);
    setCustomerData(porderData);

    setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
  };


  const defaultColumns = [
    "CompanyName",
    "Address1",
    "City",
    "Postcode",
    "Phone1",
    "AccountRef",
    "synced",
    "ModifiedBy",
    "AssignTo",
    "Email",
    "Industry",
    "vc_Category",
    "CreatedDate"
  ];

  const columnOptions = [
    { value: "CompanyName", label: "Customer" },
    { value: "Address1", label: "	Address" },
    { value: "City", label: "Town/ City" },
    { value: "Postcode", label: "Post Code" },
    { value: "Phone1", label: "	Telephone" },
    { value: "AccountRef", label: "Account Ref" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "synced", label: "Synced" },
    { value: "Email", label: "Email" },
    { value: "ModifiedBy", label: "ModifiedBy" },
    { value: "AssignTo", label: "AssignTo" },
    { value: "vc_Category", label: "Category" },
    { value: "Industry", label: "Industry" },
    { value: "CreatedDate", label: "CreatedDate" }
  ];

  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`CustomerColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`CustomerColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };

  const handleExportExcel = async () => {
    debugger;
    if (multipleIds.length === 0) {
      Swal.fire(
        'Warning!',
        'Please select at least one record to export.',
        'warning'
      );
      return;
    }
    setLoading(true);
    try {

      // Filter only selected customers
      const selectedCustomers = customerList.filter(customer =>
        multipleIds.includes(customer.ClientCompanyID)
      );

      if (!selectedCustomers || selectedCustomers.length === 0) {
        Swal.fire(
          'Warning!',
          'No selected data to export.',
          'warning'
        );
        return;
      }

      const fields = await ImportTableService.GetAllImportFields(redirectCallback, "1");
      if (!fields || fields.length === 0) {
        Swal.fire(
          'Warning!',
          'No field definitions found for export.',
          'warning'
        );
        return;
      }
      const headers = fields.map(field => field.vc_DisplayName || field.vc_FieldName || field);

      const rows = selectedCustomers.map(row =>
        fields.map(field => {
          const col = field.vc_FieldName || field; // Key name in row object
          let value = row[col];

          // Special handling for full name concatenation
          
          if (col === "Industry") {
            value = `${row.vc_Category ?? ""}`;
          }
          if (col === "Category") {
            value = `${row.IndustrialSector ?? ""}`;
          }
          if (col === "Country") {
            value = `${row.vc_CountryName ?? ""}`;
          }
          if (col === "JobRoleID") {
            value = `${row.JobRole ?? ""}`;
          }
          if (col === "Telephone") {
            value = `${row.Phone1 ?? ""}`;
          }
          if (col === "Mobile") {
            value = `${row.Phone2 ?? ""}`;
          }
          



          // Format value safely for CSV
          return `"${(value ?? '').toString().replace(/"/g, '""')}"`;
        }).join(',')
      );

      const csvContent = [
        headers.join(','), // CSV Header
        ...rows            // CSV Rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'SelectedCustomerList.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting selected customers:', error);
    } finally {
      setLoading(false);
    }
  };

  const [showColumnModal, setShowColumnModal] = useState(false);
  const handleAssignToUser = async (event) => {
    event.preventDefault();
    if (multipleIds.length === 0) {
      Swal.fire("Error", "Please select at least one record.", "warning");
      setSelectedUser(""); // reset dropdown
      return;
    }

    try {

      setShowColumnModal(true);
    } catch (error) {
      console.error("Error assigning user:", error);
      Swal.fire("Error", "Failed to assign records.", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleddlAssignToUser = async (userId) => {
    if (multipleIds.length === 0) {
      Swal.fire("Error", "Please select at least one record.", "warning");
      setSelectedUser(""); // reset dropdown
      return;
    }

    try {
      setLoading(true);
      await LeadService.AssignLeadToUser(multipleIds, userId, "Customer");
      Swal.fire("Success", "Records assigned successfully.", "success");
      setMultipleIds([]); // clear selection
      setSelectedUser(""); // reset dropdown
      fetchCustomer("0", pageSize);
    } catch (error) {
      console.error("Error assigning user:", error);
      Swal.fire("Error", "Failed to assign records.", "error");
    } finally {
      setLoading(false);
    }
  };


  const handleEmailClick = async (event, customer) => {

    event.stopPropagation();
    setEmail(customer.Email);
    setLeadIDForEmail(customer.ClientContactID);
    setIsEmailModalOpen(true);

  };
  const handleCloseEmailModal = async () => {
    setIsEmailModalOpen(false);
    setIsMultipleEmailModalOpen(false);
    fetchCustomer("0", pageSize);
  };

  const [isEmailingModalOpen, setIsEmailingModalOpen] = useState(false);
  const [emailingName, setEmailingName] = useState("");
  const handleEmailing = async () => {
    if (multipleIds.length === 0) {
      Swal.fire('Warning!', 'Please select at least one record.', 'warning');
      return;
    }
    setIsEmailingModalOpen(true); // open the modal instead of calling the API directly
  };
  const handleConfirmEmailing = async () => {
    if (!emailingName.trim()) {
      Swal.fire('Warning!', 'Please enter a name.', 'warning');
      return;
    }

    try {
      await CustomerService.AddEmailing(multipleIds, "2", emailingName);
      setMultipleIds([]);
      fetchCustomer("0", pageSize);
      setSelectedId("0");
      Swal.fire('Success!', `${multipleIds.length} record(s) have been saved successfully.`, 'success');
    } catch (error) {
      Swal.fire('Error!', 'Failed to save record.', 'error');
    } finally {
      setIsEmailingModalOpen(false);
      setEmailingName("");
    }
  };

  const handleEmailingList = async () => {
    setIsCustomerEmailing(true);
  }
  const handleCloseEmailListModal = async () => {
    setIsCustomerEmailing(false);
  };

  const handleSelect = async (EmailingName) => {
    setEmailName(EmailingName);
    setCurrentPage(1);
    setCustomerData([]);
    const query = searchQuery.toLowerCase();
    setIsCustomerEmailing(false);

    const leadData = await CustomerService.GetAllNewCustomers(redirectCallback, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), EmailingName.toString(), searchColumns.toString());
    setCustomerData(leadData);

    const leadCount = await CustomerService.GetCustomerCount(redirectCallback, searchQuery, EmailingName.toString(), searchColumns.toString());
    setPOCount(leadCount[0].TotalRecords);
    setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));
  };
  const handleReset = async () => {
    setEmailName("");
    setCurrentPage(1);
    setCustomerData([]);
    const query = searchQuery.toLowerCase();
    setIsCustomerEmailing(false);

    const leadData = await CustomerService.GetAllNewCustomers(redirectCallback, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), "", searchColumns.toString());
    setCustomerData(leadData);

    const leadCount = await CustomerService.GetCustomerCount(redirectCallback, searchQuery, "", searchColumns.toString());
    setPOCount(leadCount[0].TotalRecords);
    setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));
  };
  const handleUnAssignToUser = async (userId) => {
    if (multipleIds.length === 0) {
      Swal.fire("Error", "Please select at least one record.", "warning");
      setSelectedUser(""); // reset dropdown
      return;
    }

    try {
      setLoading(true);
      await LeadService.UnAssignLeadToUser(multipleIds, "Customer");
      Swal.fire("Success", "Records unassigned successfully.", "success");
      setMultipleIds([]); // clear selection
      setSelectedUser(""); // reset dropdown
      fetchCustomer("0", pageSize);
    } catch (error) {
      console.error("Error assigning user:", error);
      Swal.fire("Error", "Failed to assign records.", "error");
    } finally {
      setLoading(false);
    }
  };

  const defaultColumnsForSearch = [
    "CompanyName",
    "Address1",
    "City",
    "Postcode",
    "Phone1",
    "AccountRef",
    "synced",
    "Email",
    "ModifiedBy",
    "AssignTo",
    "Industry",
    "vc_Category",
    "CreatedDate"
  ];
  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
  const columnSearchOptions = [
    { value: "CompanyName", label: "Customer" },
    { value: "Address1", label: "	Address" },
    { value: "City", label: "Town/ City" },
    { value: "Postcode", label: "Post Code" },
    { value: "Phone1", label: "	Telephone" },
    { value: "AccountRef", label: "Account Ref" },
    { value: "Email", label: "Email" },
    { value: "ModifiedBy", label: "ModifiedBy" },
    { value: "AssignTo", label: "AssignTo" },
    { value: "vc_Category", label: "Category" },
    { value: "Industry", label: "Industry" },
    { value: "CreatedDate", label: "CreatedDate" }


  ];
  const handleSearchColumnChange = (selectedOptions) => {
    setSearchColumns(selectedOptions);

  };

  const [inboxModalOpen, setInboxModalOpen] = useState(false);
  const handleInboxEmail = async (event) => {
    if (multipleIds.length > 0) {
      event.preventDefault();
      setInboxModalOpen(true);
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to process.',
        'warning'
      );
    }
  }
  const handleCloseInbox = () => {
    setInboxModalOpen(false);
  };
  const handleInboxSave = async (selectedEmails) => {
    const LeadID = multipleIds[0];

    const reponse = await LeadService.CreateCommuncationInbox(selectedEmails, LeadID, "Customer");
    if (reponse.message == "Record saved successfully") {
      Swal.fire(
        'Success!',
        'Your record has been saved.',
        'success'
      );
    }
  };

  const getInitialWidths = () => {
    const saved = Cookies.get(`CustomerColumnWidths_${CompanyID}_${UserID}`);
    const defaults = {};

    visibleColumns.forEach(col => {
      defaults[col] = 110;
    });

    if (!saved) return defaults;

    const parsed = JSON.parse(saved);
    const applied = {};

    visibleColumns.forEach(col => {
      applied[col] = parsed[col] || 110;
    });

    return applied;
  };

  const [columnWidths, setColumnWidths] = useState(getInitialWidths);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);
  const MIN_COL_WIDTH = 60;

  /**
   * Load widths from cookie when visibleColumns changes
   */
  useEffect(() => {
    const savedWidths = Cookies.get(`CustomerColumnWidths_${CompanyID}_${UserID}`);
    if (savedWidths) {
      const parsed = JSON.parse(savedWidths);
      setColumnWidths((prev) => ({
        ...prev,
        ...parsed
      }));
    }
  }, [customerList]);


  /**
   * Start Column Resize
   */
  const startResize = (e, key) => {
    e.stopPropagation();
    startX.current = e.clientX;
    resizingColumn.current = key;

    const th = e.target.closest("th");   // FIXED HERE
    startWidth.current = th.offsetWidth;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
  };

  /**
   * Resize Column dynamically
   */
  const resizeColumn = (e) => {
    if (!resizingColumn.current) return;

    const delta = e.clientX - startX.current;
    const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

    setColumnWidths(prev => ({
      ...prev,
      [resizingColumn.current]: newWidth
    }));
  };
  useEffect(() => {
    setColumnWidths(getInitialWidths());
  }, [visibleColumns]);

  /**
   * Stop resizing and save to cookie
   */
  const stopResize = () => {
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);

    const key = resizingColumn.current;
    if (key) {
      setColumnWidths(prev => {
        // Save using the most recent updated state
        Cookies.set(
          `CustomerColumnWidths_${CompanyID}_${UserID}`,
          JSON.stringify(prev),
          { expires: 365 }
        );
        return prev;
      });
    }

    resizingColumn.current = null;
  };


  /**
   * Auto-fit column width
   */
  const autoFitColumn = (key) => {
    const cells = document.querySelectorAll(`[data-col='${key}']`);
    let maxWidth = 0;

    cells.forEach(cell => {
      maxWidth = Math.max(maxWidth, cell.scrollWidth);
    });

    const newWidth = maxWidth + 20;

    const updated = { ...columnWidths, [key]: newWidth };

    setColumnWidths(updated);

    Cookies.set(
      `CustomerColumnWidths_${CompanyID}_${UserID}`,
      JSON.stringify(updated),
      { expires: 365 }
    );
  };

  const handleSyncInboxEmail = async (event) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to sync inbox emails`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await LeadService.SyncInboxEmail();
          if (response.message === "Record saved successfully") {
            Swal.fire(
              'Success!',
              'Your request for syning the inbox email is process successfully.',
              'success'
            );
          }
        } catch (error) {

          Swal.fire(
            'Error!',
            'There was a problem syncing the record.',
            'error'
          );
        }
      }
    });
  }

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [reportTitle, setReportTitle] = useState('');
  const [reportLink, setReportLink] = useState('');
  const [inputValues, setInputValues] = useState({});
  const [outputData, setOutputData] = useState([]);
  const [error, setError] = useState(null);
  const getMergedPDFBytes = async (id) => {
    try {
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const redirectCallback = () => navigate('/');

      let reportData = await ReportService.GetCompanyReports(redirectCallback, "2");
      reportData = reportData.filter(x => x.IsDefault.toString() === "1");

      const reportID = reportData.length > 0 ? reportData[0].ID : 117;
      const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

      const queryObjMain = {
        ...currentInputValues,
        format: 'pdf',
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const responseMain = await axiosInstance.get(
        `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
        { responseType: 'blob' }
      );

      const mainPdfBytes = await responseMain.data.arrayBuffer();

      const pdfDoc = await PDFDocument.load(mainPdfBytes);

      return pdfDoc;

    } catch (err) {
      console.error(err);
      return null;
    }
  };
  const handlePrintUser = async (event) => {
    event.stopPropagation();


    setLoading(true);
    const includeTerms = false;

    if (multipleIds.length > 0) {
      try {
        const finalMergedPdf = await PDFDocument.create();

        // ================= MERGE INVOICES =================
        for (const id of multipleIds) {

          const pdfDoc = await getMergedPDFBytes(id);

          if (!pdfDoc) continue;

          const pages = await finalMergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );

          pages.forEach(page => finalMergedPdf.addPage(page));
        }

        const finalBytes = await finalMergedPdf.save();
        const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

        const finalUrl = URL.createObjectURL(finalBlob);
        setLoading(false);
        setPdfUrl(finalUrl);
        setShowPdfModal(true);

      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }
    } else {
      Swal.fire(
        'Error!',
        'Please check at least one record to print job.',
        'warning'
      );
    }
  };

  const handleStart = (e, ui) => {
    e.stopPropagation();
  }

  const handleSendMultipleEmail = async () => {
    if (multipleIds.length > 0) {

      const emails = multipleIds
        .map(id => {
          const contact = customerList.find(c => c.ClientCompanyID === id);
          return contact ? contact.Email : '';
        })
        .filter(email => email);
      setMultipleEmails(emails);
      setIsMultipleEmailModalOpen(true);

    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to send email.',
        'error'
      );
    }
  }


  return (
    <div>
      <Common showAddButton={'yes'} handleAddTask={handleCreateCustomerClick}
        showReportButton={'yes'} handleReports={generatePDF}
        showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick} ModuleID={"2"}
        showSynchronize={'yes'} handleSynchronize={handleSynchronize}
        isDisabled={multipleIds.length > 1}
        showExportButton={'yes'} handleExportExcel={handleExportExcel}
        showSendEmailing={'yes'} handleEmailing={handleEmailing}
        showEmailButton={'yes'} handleSendEmail={handleSendMultipleEmail}
        showEmailingList={'yes'} handleEmailingList={handleEmailingList}
        showResetEmailingList={'yes'} handleReset={handleReset}
        showUnAssignUser={'yes'} handleUnAssignToUser={handleUnAssignToUser}
        showAssignUser={'yes'} handleAssignToUser={handleAssignToUser}
        showInboxEmail={'yes'} handleInboxEmail={handleInboxEmail}
        showSyncInboxEmail={'yes'} handleSyncInboxEmail={handleSyncInboxEmail}
        assignmentTitle="Manage Cus..." titleBar="Manage Customers"
        showPrintUser={'yes'} handlePrintUser={handlePrintUser}
        HelpFormName="Customer List" HelpModule="3"
        RecordID={multipleIds}
      />
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}

      <div className="main-content-header">
        <div className="row align-items-center">
          <div className="col-xl-2">
            <h1>{t('customers')}</h1>
          </div>



          <div className="col-xl-10 d-flex justify-content-end">
            <div className="col-sm-2">

            </div>
            <div className="col-sm-2 d-flex">

            </div>
            <ColumnOptionDropDown
              options={columnOptions}
              selectedOptions={visibleColumns}
              onChange={handleColumnChange}
            />

          </div>
        </div>
      </div>


      <div className="row">
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">
              <div className="table-responsive" style={{ overflow: "visible" }}>
                <div className="row mb-3">
                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>

                    <MultiSearchDropDown
                      options={columnSearchOptions}
                      selectedOptions={searchColumns}
                      onChange={handleSearchColumnChange}
                    />
                  </div>
                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      list="recent-searches"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control me-2"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <datalist id="recent-searches">
                      {recentSearches.map((item, idx) => (
                        <option key={idx} value={item.SearchQuery} />
                      ))}
                    </datalist>
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>



                </div>
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table
                    style={{
                      tableLayout: "fixed",
                      width: "max-content",
                      minWidth: "100%"
                    }}
                    className="table m-0 table-hover"
                    ref={tableRef}
                  >
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th
                          className="checkbox-header"
                          style={{
                            width: "40px",
                            minWidth: "40px",
                            maxWidth: "40px",
                            position: "sticky",
                            left: 0,
                            zIndex: 5,

                          }}
                        ></th>
                        {visibleColumns.includes("CompanyName") &&
                          <th onClick={() => handleSort('CompanyName')}
                            style={{
                              width: `${columnWidths?.CompanyName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('customer')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'CompanyName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "CompanyName");
                              }}
                              onDoubleClick={() => autoFitColumn("CompanyName")}
                            /></th>
                        }
                        {visibleColumns.includes("Address1") &&
                          <th onClick={() => handleSort('Address1')}
                            style={{
                              width: `${columnWidths?.Address1}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('address')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'Address1'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "Address1");
                              }}
                              onDoubleClick={() => autoFitColumn("Address1")}
                            /></th>
                        }
                        {visibleColumns.includes("City") &&
                          <th onClick={() => handleSort('City')}
                            style={{
                              width: `${columnWidths?.City}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('city')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'City'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "City");
                              }}
                              onDoubleClick={() => autoFitColumn("City")}
                            /></th>
                        }
                        {visibleColumns.includes("Postcode") &&
                          <th onClick={() => handleSort('Postcode')}

                            style={{
                              width: `${columnWidths?.Postcode}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('postCode')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'Postcode'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "Postcode");
                              }}
                              onDoubleClick={() => autoFitColumn("Postcode")}
                            /></th>
                        }
                        {visibleColumns.includes("Phone1") &&
                          <th onClick={() => handleSort('Phone1')}

                            style={{
                              width: `${columnWidths?.Phone1}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('telephone')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'Phone1'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "Phone1");
                              }}
                              onDoubleClick={() => autoFitColumn("Phone1")}
                            /></th>
                        }
                        {visibleColumns.includes("Email") &&
                          <th onClick={() => handleSort('Email')}

                            style={{
                              width: `${columnWidths?.Email}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Email<i
                              className={`ms-1 icofont ${sortConfig.key === 'Email'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "Email");
                              }}
                              onDoubleClick={() => autoFitColumn("Email")}
                            /></th>
                        }
                        {visibleColumns.includes("AccountRef") &&
                          <th onClick={() => handleSort('AccountRef')}
                            style={{
                              width: `${columnWidths?.AccountRef}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('accountRef')}<i
                              className={`ms-1 icofont ${sortConfig.key === 'AccountRef'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "AccountRef");
                              }}
                              onDoubleClick={() => autoFitColumn("AccountRef")}
                            /></th>
                        }
                        {visibleColumns.includes("vc_Category") &&
                          <th onClick={() => handleSort('vc_Category')}
                            style={{
                              width: `${columnWidths?.vc_Category}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Category
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_Category'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_Category");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_Category")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("Industry") &&
                          <th onClick={() => handleSort('Industry')}
                            style={{
                              width: `${columnWidths?.Industry}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Industry
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'Industry'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "Industry");
                              }}
                              onDoubleClick={() => autoFitColumn("Industry")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("UpdatedDate") &&
                          <th onClick={() => handleSort('UpdatedDate')}

                            style={{
                              width: `${columnWidths?.UpdatedDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Last Action
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'UpdatedDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "UpdatedDate");
                              }}
                              onDoubleClick={() => autoFitColumn("UpdatedDate")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("AssignTo") &&
                          <th onClick={() => handleSort('AssignTo')}

                            style={{
                              width: `${columnWidths?.AssignTo}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Assign To
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'AssignTo'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "AssignTo");
                              }}
                              onDoubleClick={() => autoFitColumn("AssignTo")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("ModifiedBy") &&
                          <th onClick={() => handleSort('ModifiedBy')}
                            style={{
                              width: `${columnWidths?.ModifiedBy}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Modified By
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ModifiedBy");
                              }}
                              onDoubleClick={() => autoFitColumn("ModifiedBy")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("synced") &&
                          <th

                            style={{
                              width: `${columnWidths?.synced}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('synced')}</th>
                        }

                        {visibleColumns.includes("CreatedDate") &&
                          <th onClick={() => handleSort('CreatedDate')}

                            style={{
                              width: `${columnWidths?.CreatedDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Created Date
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'CreatedDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "CreatedDate");
                              }}
                              onDoubleClick={() => autoFitColumn("CreatedDate")}
                            />
                          </th>
                        }
                      </tr>
                    </thead>
                    <tbody>

                      {customerList.map((customer, index) => (
                        <tr key={customer.ClientCompanyID}
                          onClick={() => handleEditClick(customer.ClientCompanyID)}
                          style={{
                            backgroundColor: selectedId.toString() === customer.ClientCompanyID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                            cursor: 'pointer',
                          }}
                        >
                          <td
                            className="checkbox-cell"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "40px",
                              minWidth: "40px",
                              maxWidth: "40px",
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                              backgroundColor:
                                selectedId.toString() === customer.ClientCompanyID.toString()
                                  ? 'rgb(197, 218, 237)'
                                  : '#fff'
                            }}
                          >
                            <div
                              className="checkbox-hover-area"
                              onClick={(event) => handleCheckboxClick(event, customer.ClientCompanyID, index)}
                            >
                              <input
                                type="checkbox"
                                checked={multipleIds.includes(customer.ClientCompanyID)}
                                readOnly
                              />
                            </div>
                          </td>
                          {visibleColumns.includes("CompanyName") && <td style={{
                            width: columnWidths.CompanyName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={customer.CompanyName}>{customer.CompanyName}</td>}
                          {visibleColumns.includes("Address1") && <td style={{
                            width: columnWidths.Address1,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={customer.Address1}>{customer.Address1}</td>}
                          {visibleColumns.includes("City") && <td style={{
                            width: columnWidths.City,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={customer.City}>{customer.City}</td>}
                          {visibleColumns.includes("Postcode") && <td style={{
                            width: columnWidths.Postcode,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={customer.Postcode}>{customer.Postcode}</td>}
                          {visibleColumns.includes("Phone1") && <td style={{
                            width: columnWidths.Phone1,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={customer.Phone1}>
                            <a href={`tel:${customer.Phone1}`} onClick={(e) => e.stopPropagation()}>
                              {customer.Phone1}
                            </a>
                          </td>}
                          {visibleColumns.includes("Email") &&
                            <td style={{
                              width: columnWidths.Email,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={customer.Email}>
                              <a href='#' onClick={(event) => handleEmailClick(event, customer)}>
                                {customer.Email && customer.Email.length > 12
                                  ? `${customer.Email.substring(0, 12)}...`
                                  : customer.Email}
                              </a>
                            </td>
                          }

                          {visibleColumns.includes("AccountRef") && <td style={{
                            width: columnWidths.AccountRef,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={customer.AccountRef}>{customer.AccountRef}</td>}
                          {visibleColumns.includes("vc_Category") && <td style={{
                            width: columnWidths.vc_Category,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{customer.IndustrialSector} </td>}
                          {visibleColumns.includes("Industry") && <td style={{
                            width: columnWidths.Industry,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{customer.vc_Category} </td>}
                          {visibleColumns.includes("UpdatedDate") && <td style={{
                            width: columnWidths.UpdatedDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDateWithFns(customer.UpdatedDate, activeDateFormat)}  </td>}
                          {visibleColumns.includes("AssignTo") && <td style={{
                            width: columnWidths.AssignTo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {customer.AssignTo ? (
                              <div
                                title={customer.AssignTo}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {customer.AssignTo.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("ModifiedBy") && <td style={{
                            width: columnWidths.ModifiedBy,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {customer.ModifiedBy ? (
                              <div
                                title={customer.ModifiedBy}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#368938",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {customer.ModifiedBy.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("synced") &&
                            <td style={{
                              width: columnWidths.synced,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">
                              {customer.IsSynced === 1 && (
                                <img src='assets/img/resources/tick.png' style={{ width: "20px" }}></img>
                              )}
                              {customer.IsSynced === 2 && (
                                <img src='assets/img/resources/sync.JPG' style={{ width: "50px" }}></img>
                              )}
                            </td>
                          }

                          {visibleColumns.includes("CreatedDate") && <td style={{
                            width: columnWidths.CreatedDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDateWithFns(customer.CreatedDate, activeDateFormat)}  </td>}

                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                            {/* Last Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} /> Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} /> First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                </div>
                {isModalOpen && (
                  <CreateCustomerModal
                    ClientCompanyID={localStorage.getItem('ClientCompanyID')}
                    onClose={handleCloseModal}
                    onSuccess={fetchCustomer}
                    onNext={handleNext} onPrevious={handlePrevious}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isEmailModalOpen && (
        <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} Module="Customer" ModuleID={LeadIDForEmail} />
      )}
      {isCustomerEmailing && (
        <CustomerEmailingList
          show={isCustomerEmailing}
          onClose={handleCloseEmailListModal}
          ModuleID={"2"}
          handleSelect={handleSelect}
          OnReset={handleReset}
        />
      )}
      {isEmailingModalOpen && (
        <div className="modal show fade" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Emailing Name</h5>
                <button type="button" className="btn-close" onClick={() => setIsEmailingModalOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "10px" }}>

                  <div className="col-sm-12">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Name"
                      value={emailingName}
                      onChange={(e) => setEmailingName(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setIsEmailingModalOpen(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={handleConfirmEmailing}>Save</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showColumnModal && (
        <div
          className="modal show fade"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Assign Engineer</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowColumnModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "10px" }}>

                  <div className="col-sm-12">
                    {selectedRoleName === "Administrator" && (
                      <UserDropdown
                        value={selectedUser}
                        onChange={(val) => {
                          setSelectedUser(val);
                          if (val) handleddlAssignToUser(val);
                        }}
                        showLabel={false}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowColumnModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {inboxModalOpen && (
        <InboxModal onSave={handleInboxSave} onClose={handleCloseInbox} />
      )}
      {showPdfModal && pdfUrl && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <Draggable handle=".modal-content" onStart={handleStart}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">PDF Report</h5>
                  <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                </div>
              </div>
            </Draggable>
          </div>
        </div>
      )}
      {isMultipleEmailModalOpen && (
        <MultipleEmail
          onClose={handleCloseEmailModal}
          ToEmail={multipleEmails} // remove empty strings
          Module="Contact"
          ModuleID={LeadIDForEmail}
          MultipleIDs={multipleIds}
        />
      )}
    </div>
  );
}
export default CustomerList;